/* import __COLOCATED_TEMPLATE__ from './form-blocks.hbs'; */
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class RequestInformationFormBlocks extends Component {
  @service session;
  @service currentPractice;

  get contactEmail() {
    // Contact/Couple use emails relationship, Client uses email attribute
    return (
      this.args.contact?.emails?.firstObject?.address ||
      this.args.you?.emails?.firstObject?.address ||
      this.args.client?.email
    );
  }

  get contactPhone() {
    return (
      this.args.contact?.phones?.firstObject?.number ||
      this.args.you?.phones?.firstObject?.number ||
      this.args.client?.phoneNumber
    );
  }

  get contactFullName() {
    let contact = this.args.contact || this.args.you || this.args.client;
    let firstName = contact?.firstName || '';
    let lastName = contact?.lastName || '';
    return `${firstName} ${lastName}`.trim();
  }

  @action
  onInput({ target }) {
    this.args.onInputChange?.({ target });
  }

  @action
  onSubmitClick() {
    this.args.nextStep?.('desktop', this.args.stripeElements);
  }

  @action
  onMobileSubmitClick() {
    this.args.nextStep?.('', this.args.stripeElements);
  }
}
